export const calculateItemsTotals = (items = []) => {
  return items.reduce(
    (acc, item) => {
      acc.payable += item.payable || 0;
      acc.tax += item.tax || 0;
      acc.cess += item.cess || 0;
      return acc;
    },
    { payable: 0, tax: 0, cess: 0 }
  );
};

export const getUpiPaymentDetails = ({ terminal, amount, description, shop }) => {
    const upiId = terminal?.upi_id || shop?.config?.upi_id || null;

    return {
        upiId,
        upiPaymentUrl: upiId
            ? `upi://pay?&pa=${upiId}${amount ? `&am=${parseFloat(amount).toFixed(2)}` : ''}${description ? `&tn=${encodeURIComponent(description)}` : ''}`
            : null,
    };
};
